
export const cropOptions = [
  { value: 'corn', label: 'Corn', yieldPerAcre: 180, pricePerBushel: 4.5 },
  { value: 'soybeans', label: 'Soybeans', yieldPerAcre: 55, pricePerBushel: 12.0 },
  { value: 'wheat', label: 'Wheat', yieldPerAcre: 70, pricePerBushel: 6.5 },
  { value: 'hay', label: 'Hay / Alfalfa', yieldPerAcre: 4, pricePerBushel: 220 },
];

export const serviceOptions = [
  {
    id: 'aerial',
    label: 'Precision Aerial Application',
    savingsPerAcre: 12,
    description: 'Eliminate wheel traffic damage and compaction losses',
  },
  {
    id: 'timing',
    label: 'Timely Fungicide Windows',
    savingsPerAcre: 0,
    yieldBoostPct: 0.10,
    description: 'Hit critical spray windows even when fields are wet',
  },
  {
    id: 'deer',
    label: 'Deer Deterrent Program',
    savingsPerAcre: 0,
    edgeRowSavings: 800,
    edgeRowPct: 0.08,
    description: 'Protect edge rows from browse damage',
  },
  {
    id: 'assessment',
    label: 'Field Assessment & Imaging',
    savingsPerAcre: 65,
    description: 'Identify drainage issues and crop stress early',
  },
];

export const compactionLossPercent = 0.04;
export const missedWindowLossPercent = 0.10;
export const deerEdgeRowDamagePerAcre = 800;
export const deerEdgeRowPercent = 0.08;
export const drainageLossPerAcre = 85;
